import React, { createContext, useContext, ReactNode } from "react";

interface ExperimentContextValue {
    /** The entity ID used for experiment evaluation (typically workspaceId). */
    distinctId: string;
}

const ExperimentContext = createContext<ExperimentContextValue>({ distinctId: "" });

/**
 * Provides the experiment distinctId to all descendant useExperiment() hooks.
 *
 * Each app wires this once at the root:
 * - Core app: reads currentWorkspaceId from globalStore
 * - Rapid: reads currentWorkspace.id from rapid's store
 */
export function ExperimentProvider({
    distinctId,
    children
}: {
    distinctId: string;
    children: ReactNode;
}) {
    return (
        <ExperimentContext.Provider value={{ distinctId }}>{children}</ExperimentContext.Provider>
    );
}

export function useExperimentContext(): ExperimentContextValue {
    return useContext(ExperimentContext);
}
